import { render, staticRenderFns } from "./OrganizationsTableWidget.vue?vue&type=template&id=300b1a9f&scoped=true"
import script from "./OrganizationsTableWidget.vue?vue&type=script&lang=js"
export * from "./OrganizationsTableWidget.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsTableWidget.vue?vue&type=style&index=0&id=300b1a9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300b1a9f",
  null
  
)

export default component.exports